"use client";

import { c as _c } from "react/compiler-runtime";
import { ProgressBarLink } from "@/components/progress-bar";
import { ProgressLine } from "@/components/ui/progress-line";
import { goLiveLabel } from "@/lib/go-live";
import { noteSetupGuideOpenSource } from "@/lib/setup-checklist-analytics";
import { firstOpen, groupBySection } from "@/lib/setup-checklist-sections";
import type { SetupChecklistResponse } from "@/types/setup-checklist";

/** Sidebar footer shown once onboarding is finished. */
export function SidebarSetupChecklist(t0) {
  const $ = _c(20);
  const {
    data
  } = t0;
  if (!data) {
    return null;
  }
  const {
    totals
  } = data;
  const days = data.daysToGoLive;
  const total = totals.open + totals.done + totals.skipped;
  const settled = totals.done + totals.skipped;
  if (total === 0 || data.finishedAt) {
    return null;
  }
  let t1;
  if ($[0] !== data.items) {
    t1 = firstOpen(groupBySection(data.items).find(_temp)?.items ?? []) ?? null;
    $[0] = data.items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const next = t1;
  let t2;
  if ($[2] !== days) {
    t2 = days === null || days === undefined ? "" : goLiveLabel(days);
    $[2] = days;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const countdown = t2;
  const t3 = next ? `/settings/setup-guide?item=${encodeURIComponent(next.id)}` : "/settings/setup-guide";
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="shrink-0 font-semibold">Setup guide</span>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== countdown) {
    t5 = <div className="flex items-baseline gap-2 pl-0.5 pr-1 text-caption">{t4}<span className="flex-1 truncate text-right tabular-nums text-foreground-secondary">{countdown}</span></div>;
    $[5] = countdown;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `Setup guide: ${settled} of ${total} items done`;
  let t7;
  if ($[7] !== settled || $[8] !== t6 || $[9] !== total) {
    t7 = <ProgressLine done={settled} total={total} label={t6} />;
    $[7] = settled;
    $[8] = t6;
    $[9] = total;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== next) {
    t8 = next ? <>{"Next: "}<span className="text-foreground">{next.definition.title}</span></> : "Finish setup";
    $[11] = next;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <p className="line-clamp-2 pl-0.5 pr-1 text-caption text-foreground-secondary">{t8}</p>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t3 || $[16] !== t5 || $[17] !== t7 || $[18] !== t9) {
    t10 = <ProgressBarLink href={t3} onClick={_temp2} className="mb-2 ml-4 mr-2 flex flex-col gap-2 rounded-lg border border-border bg-background p-2.5 text-foreground transition-colors duration-200 hover:bg-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary motion-reduce:transition-none">{t5}{t7}{t9}</ProgressBarLink>;
    $[15] = t3;
    $[16] = t5;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}
function _temp2(event) {
  return noteSetupGuideOpenSource(event, "footer_card");
}
function _temp(section) {
  return !section.isComplete;
}